/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fw_Bm_Col_MedianInputs */

const en_fw_bm_col_median = /** @type {(inputs: Fw_Bm_Col_MedianInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Median`)
};

const id_fw_bm_col_median = /** @type {(inputs: Fw_Bm_Col_MedianInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Median`)
};

/**
* | output |
* | --- |
* | "Median" |
*
* @param {Fw_Bm_Col_MedianInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const fw_bm_col_median = /** @type {((inputs?: Fw_Bm_Col_MedianInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fw_Bm_Col_MedianInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_fw_bm_col_median(inputs)
	return en_fw_bm_col_median(inputs)
});